import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { RootState } from "@/redux";

import {
	DEFAULT_SEND_ERROR_RANGE,
	SendErrorRange,
} from "../../pages/SupportDashboard/schema/support-dashboard";

interface SupportDashboardState {
	sendErrorRange: SendErrorRange;
}

const initialState: SupportDashboardState = {
	sendErrorRange: DEFAULT_SEND_ERROR_RANGE,
};

export const supportDashboardSlice = createSlice({
	name: "supportDashboard",
	initialState,
	reducers: {
		setSendErrorRange: (state, { payload }: PayloadAction<SendErrorRange>) => {
			state.sendErrorRange = payload;
		},
	},
});

export const { setSendErrorRange } = supportDashboardSlice.actions;
export const supportDashboardReducer = supportDashboardSlice.reducer;
export const supportDashboardSelector = (state: RootState) => state[supportDashboardSlice.name];
